import { isError } from 'resift';

function getHasError(status: any) {
  if (typeof status === 'number') {
    return isError(status);
  }

  return status.hasError();
}

export default getHasError;
